
import Vue from 'vue'

interface AccountItem {
  link: string,
  title: string
}

export default Vue.extend({
  name: 'HeaderAccount',
  props: {
    customerName: {
      type: String,
      default: ''
    },
    customerEmail: {
      type: String,
      default: ''
    },
    accountLink: {
      type: String,
      required: true
    }
  },
  data(): {
    openMenu: boolean,
    accountLinks: AccountItem[]
  }{
    return {
      openMenu: false,
      accountLinks: [{
        title: 'Update Account Information',
        link:  `${this.accountLink}/profile`
      },
      {
        title: 'Senders Address',
        link:  `${this.accountLink}/sender_addresses`
      },
      {
        title: 'Recipient Address',
        link:  `${this.accountLink}/recipient_addresses`
      }
      ]
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside)
  },
  destroyed() {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    onLogoutHandler(): void {
      window.location.replace(`${this.accountLink}/sign_out`)
    },
    handleClickOutside(event: any) {
      if (!this.$el.contains(event.target)) {
        this.openMenu = false
      }
    }
  }
})
